import { render, staticRenderFns } from "./activeTeamChatLog.vue?vue&type=template&id=21f741b6&"
import script from "./activeTeamChatLog.vue?vue&type=script&lang=js&"
export * from "./activeTeamChatLog.vue?vue&type=script&lang=js&"
import style0 from "./activeTeamChatLog.vue?vue&type=style&index=0&id=21f741b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports